<app-lms-modal-frame [title]="'User Change Log Report'" [pageHeadWidth]="500">
  <div modal-body>
    <section *ngIf="userChangeLogList.length > 0">
      <div>
        <lms-table-wrapper [config]="config">
          <table
            class="table table-sm table-striped table-borderless table-primary ms-auto me-auto table-center-header shadow-2-strong rounded-1 p-1 w-75"
          >
            <caption>
              Change Log
            </caption>
            <thead>
              <tr class="text-nowrap">
                <th scope="col">Date/Time</th>
                <th scope="col">Branch Name</th>
                <th scope="col">Change by</th>
                <th scope="col">Change Type</th>
                <th scope="col" style="width: 410px; max-width: 500px">
                  Previous Data
                </th>
                <th scope="col" style="width: 410px; max-width: 500px">
                  New Data
                </th>
              </tr>
            </thead>
            <tbody
              class="center-fields table-bordered text-bg-light table-light table-hover table-group-divider"
            >
              <tr *ngFor="let log of userChangeLogList | paginate: config">
                <td>{{ log?.actionDatetime | date: "yyyy/MM/dd" }}</td>
                <td>{{ log.branch?.branchName }}</td>
                <td>{{ log.changedBy?.nameSurname }}</td>
                <td>{{ log.action }}</td>
                <td
                  class="text-wrap"
                  style="
                    width: 410px;
                    max-width: 500px;
                    white-space: normal;
                    word-wrap: break-word;
                  "
                >
                  {{ log.previousData }}
                </td>
                <td
                  class="text-wrap"
                  style="
                    width: 410px;
                    max-width: 500px;
                    white-space: normal;
                    word-wrap: break-word;
                  "
                >
                  {{ log.newData }}
                </td>
              </tr>
            </tbody>
          </table>
        </lms-table-wrapper>
        <br />
      </div>

      <div class="center-screen table-responsive" #TABLE>
        <table
          #table
          hidden="true"
          class="table table-sm table-striped table-borderless table-primary ms-auto me-auto table-center-header shadow-2-strong rounded-1 p-1 w-75"
        >
          <caption>
            Change Log Results
          </caption>
          <thead>
            <tr class="text-nowrap">
              <th scope="col">Date/Time</th>
              <th scope="col">Branch Name</th>
              <th scope="col">Change by</th>
              <th scope="col">Change Type</th>
              <th scope="col">Previous Data</th>
              <th scope="col">New Data</th>
            </tr>
          </thead>
          <tbody
            class="center-fields table-bordered text-bg-light table-light table-hover table-group-divider"
          >
            <tr *ngFor="let log of userChangeLogList" class="text-nowrap">
              <td>{{ log?.actionDatetime }}</td>
              <td>{{ log.branch?.branchName }}</td>
              <td>{{ log.changedBy?.nameSurname }}</td>
              <td>{{ log.action }}</td>
              <td>{{ log.previousData }}</td>
              <td>{{ log.newData }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <div modal-actions class="lms-action-bar">
    <button class="btn btn-primary me-2" (click)="exportLogsToExcel()">Export to Excel</button>
    <button class="btn btn-secondary" type="button" (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
